import React from 'react';
import { HashRouter as Router, Route } from "react-router-dom";
// import Header from './layouts/Header';
// import Footer from './layouts/Footer';
import AssetTrust from './views/AssetTrust';
import InfoDisclosure from './views/InfoDisclosure'
import RaiseAccount from './views/RaiseAccount'
import ConcatAsset from './views/ConcatAsset'
import FundService from './views/FundService'
import TrustService from './views/TrustService'
import AchieveAboard from './views/AchieveAboard'

function App() {
  return (
    <div className="App">
      <Router>
        {/* <Header/> */}
        <Route path="/" exact component={ AssetTrust }/>
        <Route path="/infoDisclosure" component={InfoDisclosure}/>
        <Route path="/raiseAccount" component={RaiseAccount}/>
        <Route path="/concatAsset" component={ConcatAsset}/>
        <Route path="/fundService" component={FundService}/>
        <Route path="/trustService" component={TrustService}/>
        <Route path="/achieveAboard" component={AchieveAboard}/>
        {/* <Footer/> */}
      </Router>
    </div>
  );
}

export default App;
